import { iconButton, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';

const { spacing } = dggTheme;

export const headerSpacer = css`
  height: ${pxToRem(106)};
`;

export const header = css`
  position: fixed;
  top: ${pxToRem(12)};
  left: 0;
  right: 0;
  z-index: 3;
  max-width: ${pxToRem(1440)};
  margin: 0 auto;
  padding: 0 ${pxToRem(spacing.md)};
`;

export const headerInner = css`
  background: var(--dgg-well-read);
  padding: ${pxToRem(12)} ${pxToRem(12)};
  border: 1px solid #fff;
  border-radius: ${pxToRem(6)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const siteLogo = css`
  a {
    display: block;

    img {
      display: block;
      width: 157px;
      height: 40px;
    }
  }
`;

export const burgerMenuIcon = css`
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
`;

export const burgerMenuButton = css`
  ${iconButton}
  border: ${pxToRem(3)} solid var(--neutral-white-base);
  border-radius: 50%;
  padding: ${pxToRem(12)};
`;
